import { existingHeaders } from "./utils";
import { getAuthUrl } from "utils/env";

const resendTokenAPI = "/customer/email/token";

export const resendVerifyTokenService = {
  resendVerificationToken,
};

function resendVerificationToken(email) {
  const requestOptions = {
    method: "POST",
    headers: existingHeaders,
    body: JSON.stringify({ email: email }),
  };
  return fetch(getAuthUrl(resendTokenAPI), requestOptions);
}
